var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reg-bridge',{attrs:{"isOpen":_vm.isOpen,"userData":_vm.args},on:{"sendCode":_vm.sendCodeFn,"regDeal":_vm.regDealFn}})
}
var staticRenderFns = []

export { render, staticRenderFns }